/**
 * @file Purchase Album Folder master view.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';

import ScrollToTop from '../../components/routing/ScrollToTop';
import PurchaseAlbumFolderLayout from '../layouts/PurchaseAlbumFolderLayout';

const propTypes = {
  route: PropTypes.object,
};

const PurchaseAlbumFolderMasterView = ({ route }) => {
  return (
    <PurchaseAlbumFolderLayout>
      {renderRoutes(route.routes)}

      <ScrollToTop />
    </PurchaseAlbumFolderLayout>
  );
};

PurchaseAlbumFolderMasterView.propTypes = propTypes;

export default PurchaseAlbumFolderMasterView;
